import { render } from "./RoteiroTestador.vue?vue&type=template&id=78b11b8c&scoped=true"
import script from "./RoteiroTestador.vue?vue&type=script&lang=js"
export * from "./RoteiroTestador.vue?vue&type=script&lang=js"

import "./RoteiroTestador.vue?vue&type=style&index=0&id=78b11b8c&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78b11b8c"]])

export default __exports__